import PropTypes from 'prop-types';
import useResponsive from '../../../utils/responsive';

import Image from '../shared/image.component';
import { FadeInAnimation } from '../shared';

const MobileAppSection = (props) => {
    const { isMobile } = useResponsive();
    const { isDark, paragraph, icon, iconText, primaryImgSrc, primaryImgAlt } = props;  

    const renderDesktop = () => {
        if (!isMobile) {
            return (

                <div className='mobile-section-app-grid-container main-grid-container main-grid-spacing-xs-3'>

                    <div className='main-grid-item main-grid-lg-5 main-grid-md-6 main-grid-sm-12'>

                        {isDark ? renderDarkTextSection() : renderTextSection()}

                        <div className='mobile-section-app-desktop-and-tablet-container'>
                            <a
                                href="//play.google.com/store/apps/details?id=za.co.homii.mobile&hl=en"
                                rel="noreferrer"
                                target="_blank"
                                aria-label="google play"
                            >
                                <div className="app-download-buttons">
                                    <Image
                                        src="/assets/images/google_play.png"
                                        alt="Google Play"
                                        width={141}
                                        height={34}
                                    />
                                </div>
                            </a>
                            <a
                                href="//apps.apple.com/za/app/homii-lifestyle/id1478894335"
                                rel="noreferrer"
                                target="_blank"
                                aria-label="apple store"
                            >
                                <div className="app-download-buttons">
                                    <Image
                                        src="/assets/images/apple.png"
                                        alt="Play Store"
                                        width={141}
                                        height={34}
                                    />
                                </div>
                            </a>
                            <a
                                href="//appgallery.huawei.com/#/app/C102716343"
                                rel="noreferrer"
                                target="_blank"
                                aria-label="huawei appgallery"
                            >
                                <div className="app-download-buttons">
                                    <Image
                                        src="/assets/images/huawei.png"
                                        alt="Huawei Store"
                                        width={141}
                                        height={34}
                                    />
                                </div>
                            </a>
                        </div>

                    </div>

                    <div className='main-grid-item main-grid-lg-7 main-grid-md-6 main-grid-sm-12 mobile-section-app-app-image-grid-container'>

                        <div className='mobile-section-app-app-image-container'>
                            <Image
                                src="/assets/images/phone-min.png"
                                alt="Live the city vibe"
                                width={773}
                                height={739}
                                className='mobile-section-app-image-phone'
                            />
                        </div>

                    </div>

                </div>
            );
        }
        return null;
    };

    const renderMobile = () => {
        if (isMobile) {
            return (
                <div className='mobile-section-app-mobile-container'>
                    {isDark && <p className='dummy-header-three mobile-section-app-header-three-dark'>Download the app today</p>}
                    {!isDark && <p className='dummy-header-threemobile-section-app-header-three'>Download the app today</p>}
                    <p className={isDark ? 'mobile-section-app-dark-paragraph-text' : null}>{paragraph}</p>

                    <div className='mobile-section-app-image-container'>
                        <Image src={primaryImgSrc} alt={primaryImgAlt} className="general-image" width={446} height={605} />
                    </div>

                    <div className='mobile-section-app-grid-container'>
                        <div className='mobile-section-app-icon-container-smaller'>
                            <img className='mobile-section-app-icon' src={icon} alt="" />
                        </div>
                        <h6 className={isDark ? 'mobile-section-app-dark-caption' : 'mobile-section-app-caption'}>
                            {iconText}
                        </h6>
                    </div>
                    <div className='mobile-section-app-button-container'>
                        <div className='mobile-section-app-button-row'>
                            <a
                                href="//play.google.com/store/apps/details?id=za.co.homii.mobile&hl=en"
                                rel="noreferrer"
                                target="_blank"
                            >
                                <div className="app-download-buttons">
                                    <Image
                                        src="/assets/images/google_play.png"
                                        alt="Google Play"
                                        width={141}
                                        height={34}
                                    />
                                </div>
                            </a>

                            <a
                                href="//apps.apple.com/za/app/homii-lifestyle/id1478894335"
                                rel="noreferrer"
                                target="_blank"
                            >
                                <div className="app-download-buttons">
                                    <Image
                                        src="/assets/images/apple.png"
                                        alt="Play Store"
                                        width={141}
                                        height={34}
                                    />
                                </div>
                            </a>
                        </div>
                        <a
                            href="//appgallery.huawei.com/#/app/C102716343"
                            rel="noreferrer"
                            target="_blank"
                        >
                            <div className="app-download-buttons">
                                <Image
                                    src="/assets/images/huawei.png"
                                    alt="Play Store"
                                    width={141}
                                    height={34}
                                />
                            </div>
                        </a>
                    </div>
                </div>
            );
        }
        return null;
    };

    const renderTextSection = () => {
        return (
            <>
                <FadeInAnimation>
                    <div>
                        <p className='dummy-header-three mobile-section-app-header-three'>Download the app today</p>
                    </div>
                    <p>{paragraph}</p>
                    <div className='mobile-section-app-icon-and-text-container'>
                        <div className='mobile-section-app-icon-container'>
                            <img src={icon} alt="" />
                        </div>
                        <h6 className='mobile-section-app-caption'>{iconText}</h6>
                    </div>
                </FadeInAnimation>
            </>
        );
    };

    const renderDarkTextSection = () => {
        return (
            <>
                <FadeInAnimation>

                    <div>
                        
                        <p className='dummy-header-three mobile-section-app-header-three-dark'>Download the app today</p>
                        
                        <p className='mobile-section-app-dark-paragraph-text'>{paragraph}</p>
                        
                        <div className='mobile-section-app-dark-icon-and-text-container'>

                            <div className='mobile-section-app-dark-icon-container'>
                                <Image src={icon} alt="" isOldImage />
                            </div>

                            <h6 className='mobile-section-app-dark-caption'>{iconText}</h6>
                            
                        </div>

                    </div>

                </FadeInAnimation>
            </>
        );
    };

    return (
        <div className='container-root container-root-maxWidthLg'>
            {renderDesktop()}
            {renderMobile()}
        </div>
    );
};

export default MobileAppSection;

MobileAppSection.propTypes = {
    isDark: PropTypes.bool,
    title: PropTypes.string,
    paragraph: PropTypes.string,
    icon: PropTypes.string,
    iconText: PropTypes.string,
    primaryImgSrc: PropTypes.string,
    primaryImgAlt: PropTypes.string,
    secondaryImgSrc: PropTypes.string,
    secondaryImgAlt: PropTypes.string,
};
